// extracted by mini-css-extract-plugin
module.exports = {"dropdownMenu":"DropdownMenu_dropdownMenu__OCp0A","menuOption":"DropdownMenu_menuOption__K4uKj","divider":"DropdownMenu_divider__IaO48"};